// useMutation(mutationFn)
export type MutationVars<Params, Body> = Params & { body: Body };
